<!-- Ported from the Polaris kit: src/components/ui/kbd/Kbd.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <kbd
    :class="
      cn(
        'bg-polaris-muted text-polaris-muted-foreground pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-polaris-sm px-1 font-sans type-polaris-small-label select-none',
        `[&_svg:not([class*='size-'])]:size-3`,
        '[[data-slot=tooltip-content]_&]:bg-polaris-background/20 [[data-slot=tooltip-content]_&]:text-polaris-background dark:[[data-slot=tooltip-content]_&]:bg-polaris-background/10',
        props.class
      )
    "
  >
    <slot />
  </kbd>
</template>
